/**
 * ATS Member Role types.
 */

export enum ATSRole {
  MANAGER = 'manager',
  LEADER = 'leader',
  RECRUITER = 'recruiter',
}

export interface ATSMemberRole {
  account_id: string; // UUID
  account_name: string;
  account_email: string;
  role: ATSRole;
  is_owner: boolean; // True if workspace owner (virtual MANAGER)
  can_modify: boolean; // False for owners, true for others
}

export interface ATSMemberRoleCreate {
  account_id: string; // UUID
  role: ATSRole;
}

export interface ATSMemberRoleUpdate {
  role: ATSRole;
}

export const ATS_ROLE_LABELS: Record<ATSRole, string> = {
  [ATSRole.MANAGER]: 'Manager',
  [ATSRole.LEADER]: 'Leader',
  [ATSRole.RECRUITER]: 'Recruiter',
};

export const ATS_ROLE_DESCRIPTIONS: Record<ATSRole, string> = {
  [ATSRole.MANAGER]: 'Full access + can assign permissions to others',
  [ATSRole.LEADER]: 'Full CRUD access to all data',
  [ATSRole.RECRUITER]: 'Only assigned jobs, can only edit own CVs',
};

export const ATS_ROLE_COLORS: Record<ATSRole, { bg: string; text: string; dot: string }> = {
  [ATSRole.MANAGER]: {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    dot: 'bg-purple-500',
  },
  [ATSRole.LEADER]: {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    dot: 'bg-blue-500',
  },
  [ATSRole.RECRUITER]: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    dot: 'bg-gray-500',
  },
};
